import { Box, LinearProgress, Typography } from '@mui/material'

// ==================== ProgressIndicator ====================
// Progress bar + "completed/total Completed" label for accordion headers.
const ProgressIndicator = ({ completed, total }) => {
  const percent = total > 0 ? (completed / total) * 100 : 0
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <LinearProgress
        variant="determinate"
        value={percent}
        sx={{
          width: 200,
          height: 8,
          backgroundColor: 'var(--bg-disabled)',
          '& .MuiLinearProgress-bar': {
            backgroundColor: 'var(--chart-orange)',
          },
        }}
      />
      <Typography
        sx={{
          fontSize: 'var(--font-size-sm)',
          color: 'var(--forbrand-primary)',
          whiteSpace: 'nowrap',
        }}
      >
        {completed}/{total} Completed
      </Typography>
    </Box>
  )
}

export default ProgressIndicator
